jQuery(function ($) {
    ContentSlide();

    function ContentSlide() {
        var slideHeight = 175;
        const contentHeightOne = 991;
        const contentHeightTwo = 100;
        const contentHeightThree = 90;

        var mobcontentSlideThree;
        if (window.matchMedia('(max-width: 576px)').matches) {
            mobcontentSlideThree = 207;
            slideHeight = 295;
        } else if (window.matchMedia('(max-width: 1118px)').matches) {
            mobcontentSlideThree = 105;
        }

        const contentHeightFour = 44;
        var contentHeightDynamic;

        if (window.matchMedia('(max-width: 1118px)').matches) {
            if ($(".MobContentSlide").hasClass("ContentSlide--ProductDetails")) {
                if ($(window).width() > contentHeightOne) {
                    contentHeightDynamic = contentHeightTwo;
                } else {
                    contentHeightDynamic = mobcontentSlideThree;
                }
            } else {
                contentHeightDynamic = contentHeightFour;
            }
        } else {
            if ($(".ContentSlide").hasClass("ContentSlide--ProductDetails")) {
                if ($(window).width() > contentHeightOne) {
                    contentHeightDynamic = contentHeightTwo;
                } else {
                    contentHeightDynamic = contentHeightThree;
                }
            } else {
                contentHeightDynamic = contentHeightFour;
            }
        }

        var contentHeight = contentHeightDynamic;
        var minHeight = $(".ContentSlide").height();
        var minMobHeight = $(".MobContentSlide").height();

        $(".Button--Accordion").off("click.contentSlide");

        if (window.matchMedia('(max-width: 1118px)').matches && $('.MobContentSlide').length) {
            if (minMobHeight <= slideHeight) {
                $(".MobContentSlide").removeClass("heightAuto");
                $(".Button--AccordionWrap").hide();
            } else {
                $('.Button--AccordionWrap').css('display', 'block');
                $('.MobContentSlide').css('height', contentHeight + 'px');

                $(".Button--Accordion").on("click.contentSlide", function () {
                    var $btn = $(this);
                    var $slide = $(".MobContentSlide");
                    var isExpanded = $btn.hasClass("show-hide");

                    $slide.stop(true, true);

                    if (!isExpanded) {
                        var fullHeight = 0;
                        $slide.children().each(function () {
                            fullHeight += $(this).outerHeight(true);
                        });

                        if (fullHeight <= slideHeight) {
                            fullHeight = slideHeight + 1;
                        }

                        $slide.animate({
                            height: fullHeight
                        }, "fast");

                        $btn.addClass("show-hide");
                        $btn.html($btn.attr("show-less"));
                    } else {
                        $slide.animate({
                            height: contentHeight
                        }, "fast");

                        $btn.removeClass("show-hide");
                        $btn.html($btn.attr("show-more"));
                    }
                });
            }
        } else {
            if (minHeight <= slideHeight) {
                $(".ContentSlide").removeClass("heightAuto");
                $(".Button--AccordionWrap").hide();
            } else {
                $('.Button--AccordionWrap').css('display', 'block');
                $('.ContentSlide').css('height', contentHeight + 'px');

                $(".Button--Accordion").on("click.contentSlide", function () {
                    var $btn = $(this);
                    var $slide = $(".ContentSlide");
                    var isExpanded = $btn.hasClass("show-hide");

                    $slide.stop(true, true);

                    if (!isExpanded) {
                        var fullHeight = 0;
                        $slide.children().each(function () {
                            fullHeight += $(this).outerHeight(true);
                        });

                        $slide.animate({
                            height: fullHeight
                        }, "fast");

                        $btn.addClass("show-hide");
                        $btn.html($btn.attr("show-less"));
                    } else {
                        $slide.animate({
                            height: contentHeight
                        }, "fast");

                        $btn.removeClass("show-hide");
                        $btn.html($btn.attr("show-more"));
                    }
                });
            }
        }
    }

    var showLessMob = function () {
        $(".ContentSlide").removeClass("heightAuto");
        $(".MobContentSlide").removeClass("heightAuto");
        $(".Button--Accordion").removeClass("show-hide");
        $(".Button--Accordion").html($(".Button--Accordion").attr("show-more"));

        const contentSlideOne = 991;
        const contentSlideTwo = 100;
        const contentSlideThree = 90;
        var mobcontentSlideThree;

        if (window.matchMedia('(max-width: 576px)').matches) {
            mobcontentSlideThree = 207;
        } else if (window.matchMedia('(max-width: 1118px)').matches) {
            mobcontentSlideThree = 105;
        }

        const contentSlideFour = 44;
        var contentHeightDynamic;

        if (window.matchMedia('(max-width: 1118px)').matches) {
            if ($(".MobContentSlide").hasClass("ContentSlide--ProductDetails")) {
                if ($(window).width() > contentSlideOne) {
                    contentHeightDynamic = contentSlideTwo;
                } else {
                    contentHeightDynamic = mobcontentSlideThree;
                }
            } else {
                contentHeightDynamic = contentSlideFour;
            }

            $(".MobContentSlide").stop(true, true).animate({ height: contentHeightDynamic }, "fast");
        } else {
            if ($(".ContentSlide").hasClass("ContentSlide--ProductDetails")) {
                if ($(window).width() > contentSlideOne) {
                    contentHeightDynamic = contentSlideTwo;
                } else {
                    contentHeightDynamic = contentSlideThree;
                }
            } else {
                contentHeightDynamic = contentSlideFour;
            }

            $(".ContentSlide").stop(true, true).animate({ height: contentHeightDynamic }, "fast");
        }
    };

    showLessMob();

    $(window).on('resize', function () {
        showLessMob();
        ContentSlide();
    });
});